import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Solutions from "./components/Solutions";
import Pricing from "./components/Pricing";
import GetStarted from "./components/GetStarted";
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import NotFound from "./pages/NotFound";

// Pages
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

// Smart Scroll Manager (handles both hash and no-hash navigation)
const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      // Scroll to section if hash is present
      const scrollToSection = () => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else {
          requestAnimationFrame(scrollToSection);
        }
      };
      scrollToSection();
    } else {
      // Scroll to top on normal route change
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return null;
};

// Home page layout
const Home = () => (
  <>
    <Hero />
    <section id="about" className="scroll-mt-10">
      <AboutUs />
    </section>
    <section id="features" className="scroll-mt-10">
      <Features />
    </section>
    <section id="solutions" className="scroll-mt-10">
      <Solutions />
    </section>
    <section id="pricing" className="scroll-mt-20">
      <Pricing />
    </section>
    <section id="footer" className="scroll-mt-10">
      <GetStarted />
    </section>
  </>
);

// App wrapper
function App() {
  return (
    <Router>
      <ScrollManager />
      <div className="scroll-smooth">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} /> {/* Catch-all route */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;